
<div>
  <!-- Modale de confirmation de fermeture du jeu -->
  <b-modal
    :id="content.idHTML"
    content-class="px-1 px-md-3 py-0"
    :header-class="content.titre ? 'py-0' : 'd-none'"
    :body-class="content.message ? 'pt-3' : 'd-none'"
    footer-class="d-flex justify-content-center px-1 px-md-3 pt-0"
    centered
    hide-header-close
    no-fade
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
    modal-footer
  >
    <template #modal-header>
      <div>
        <h3 class="texte-noir text-center">{{ content.titre }}</h3>
      </div>
    </template>
    <div>
      <div class="texte-noir text-left body-3 graphik_medium">{{ content.message }}</div>
    </div>
    <template #modal-footer>
      <button
        type="button"
        class="btn btn-primaire btn-modal w-xs-auto w-md-auto px-2"
        @click.prevent="confirm()"
      >
        {{ content.libBtnConfirm }}
      </button>
      <button
        type="button"
        class="btn btn-secondaire btn-modal w-xs-auto w-md-auto px-2"
        data-dismiss="modal"
        @click="cancel"
      >
        {{ content.libBtnCancel }}
      </button>
    </template>
  </b-modal>
</div>
